import React, { useState } from "react";
import { useMediaQuery } from "react-responsive";
import MobileTeam from "./MobileTeam";
import DesktopTeam from "./DesktopTeam";
import useSystemHook from "./../../hooks/SystemHook";

const Team = () => {
  const [selectedTeam, setSelectedTeam] = useState("Management");
  const { isMobile, isTablet, isDesktop } = useSystemHook();

  const TEAM_HEADING = "Meet Our Team";
  const TEAM_DESCRIPTION =
    "Our team is committed to delivering outstanding service and expert support in every aspect of our business. With experienced and knowledgeable members, we provide personalized solutions and strive for excellence in all we do.";

  const teamInfo = [
    {
      title: "Management",
      members: [
        {
          name: "Larry Raff",
          role: "Director",
          image:
            "https://argusweb.azureedge.net/argus-web/team/team-management-larry.png",
        },
        {
          name: "Mark Raff",
          role: "Director",
          image:
            "https://argusweb.azureedge.net/argus-web/team/team-management-mark.png",
        },
        {
          name: "Moishe Raff",
          role: "COO",
          image:
            "https://argusweb.azureedge.net/argus-web/team/team-management-moshe.png",
        },
        {
          name: "Baruch Raff",
          role: "CTO",
          image:
            "https://argusweb.azureedge.net/argus-web/team/team-management-baruch.png",
        },
        {
          name: "Shifra Lazarus",
          role: "CFO",
          image:
            "https://argusweb.azureedge.net/argus-web/team/team-management-shifra.png",
        },
      ],
    },
    {
      title: "Wholesale Sales Team",
      members: [
        {
          name: "Cameron Sewmungal",
          role: "Business Development",
          image:
            "https://argusweb.azureedge.net/argus-web/team/team-placeholder.png",
          email: "camerons@argusmotoring.co.za",
          phone: "+27117475200",
          whatsapp: "+27826787743",
          linkedin: "",
        },
        {
          name: "Nicole Torres",
          role: "Flight Specialist",
          image:
            "https://argusweb.azureedge.net/argus-web/team/team-placeholder.png",
          email: "nicolet@argusmotoring.co.za",
          phone: "+27117475200",
          whatsapp: "+27836545120",
          linkedin: "",
        },
        {
          name: "Calvin Mokolane",
          image:
            "https://argusweb.azureedge.net/argus-web/team/team-sales-calvin.png",
          email: "calvinm@argusmotoring.co.za",
          phone: "+27117475200",
          whatsapp: "+27791011916",
          linkedin: "",
        },
        {
          name: "Elsa Dyssel",
          image:
            "https://argusweb.azureedge.net/argus-web/team/team-sales-elsa.png",
          email: "elsad@argusmotoring.co.za",
          phone: "+27117475200",
          whatsapp: "+27822926665",
          linkedin: "",
        },
        {
          name: "Laurence Rungasamy",
          image:
            "https://argusweb.azureedge.net/argus-web/team/team-sales-lawrence.png",
          email: "laurencer@argusmotoring.co.za",
          phone: "+27117475200",
          whatsapp: "+27718931195",
          linkedin: "",
        },
        {
          name: "Vera Venema",
          image:
            "https://argusweb.azureedge.net/argus-web/team/team-sales-vera.png",
          email: "veroniquev@argusmotoring.co.za",
          phone: "+27117475200",
          whatsapp: "+27646504111",
          linkedin: "",
        },
        // {
        //   name: "Wiseman Sibiya",
        //   image:
        //     "https://argusweb.azureedge.net/argus-web/team/team-sales-wiseman.png",
        //   email: "wisemans@argusmotoring.co.za",
        //   phone: "+27117475200",
        //   whatsapp: "+27648527886",
        //   linkedin: "",
        // },
      ],
    },
    {
      title: "Hardware Sales Team",
      members: [
        // {
        //   name: "Amy Walbank",
        //   image:
        //     "https://argusweb.azureedge.net/argus-web/team/team-sales-amy.png",
        //   email: "amyw@argusmotoring.co.za",
        //   phone: "+27117475207",
        //   whatsapp: "0836545127",
        //   linkedin: "https://www.linkedin.com/in/amy-walbank",
        // },
        {
          name: "Sanaa Dawood",
          role: "Business Development & Merchandiser",
          image:
            "https://argusweb.azureedge.net/argus-web/team/team-sales-sanaa.png",
          email: "sanaad@argusmotoring.co.za",
          phone: "+27117475200",
          whatsapp: "+27765218150",
          linkedin: "",
        },
        {
          name: "Sihle Sibanda",
          role: "Sales Representative",
          image:
            "https://argusweb.azureedge.net/argus-web/team/team-liasons-sihle.png",
          email: "sihlesenkosis@argusmotoring.co.za",
          phone: "+27117475200",
          whatsapp: "+27695480012",
          linkedin: "",
        },
      ],
    },
    {
      title: "Trade Counter Sales Team",
      members: [
        {
          name: "Danjelle Swart",
          role: "Business Development",
          image:
            "https://argusweb.azureedge.net/argus-web/team/team-sales-danjelle.jpg",
          email: "danjelles@argusmotoring.co.za",
          phone: "+27117475200",
          whatsapp: "+27832453905",
          linkedin: "",
        },
        {
          name: "Dumisane Chimsonde",
          image:
            "https://argusweb.azureedge.net/argus-web/team/team-sales-dumisani.png",
          email: "dumsanic@argusmotoring.co.za",
          phone: "+27117475200",
          whatsapp: "+27736459520",
          linkedin: "",
        },
      ],
    },
    {
      title: "Department Liaisons",
      members: [
        {
          name: "Meryke Thysse",
          role: "Warehouse/Logistics",
          image:
            "https://argusweb.azureedge.net/argus-web/team/team-liaisons-meryke.png",
          email: "meryket@argusmotoring.co.za",
          phone: "+27117475200",
          whatsapp: "+27769925586",
          linkedin: "",
        },
        {
          name: "Natasha Naidoo",
          role: "Stock Controller",
          image:
            "https://argusweb.azureedge.net/argus-web/team/team-liaisons-natasha.png",
          email: "natashan@argusmotoring.co.za",
          phone: "+27117475200",
          whatsapp: "+27836545120",
          linkedin: "",
        },
        {
          name: "Roxanne Packery",
          role: "Accounts Controller",
          image:
            "https://argusweb.azureedge.net/argus-web/team/team-placeholder.png",
          email: "roxannep@argusmotoring.co.za",
          phone: "+27117475200",
          whatsapp: "+27836545120",
        },
        {
          name: "Caleb Simango",
          role: "E-Commerce & Systems Developer",
          image:
            "https://argusweb.azureedge.net/argus-web/team/team-placeholder.png",
          email: "calebs@argusmotoring.co.za",
          phone: "+27117475200",
          whatsapp: "+27836545120",
          // linkedin: "https://linkedin.com/in/caleb-simango-b8b2b6b2",
        },
      ],
    },
  ];

  const handleTeamSelect = (teamTitle) => {
    setSelectedTeam(teamTitle);
  };

  const selectedTeamData = teamInfo.find((team) => team.title === selectedTeam);

  return (
    <>
      {isMobile ? (
        <MobileTeam
          heading={TEAM_HEADING}
          description={TEAM_DESCRIPTION}
          teamInfo={teamInfo}
          selectedTeam={selectedTeam}
          handleTeamSelect={handleTeamSelect}
          selectedTeamData={selectedTeamData}
        />
      ) : (
        <DesktopTeam
          heading={TEAM_HEADING}
          description={TEAM_DESCRIPTION}
          teamInfo={teamInfo}
          selectedTeam={selectedTeam}
          handleTeamSelect={handleTeamSelect}
          selectedTeamData={selectedTeamData}
        />
      )}
    </>
  );
};

export default Team;
